import { render } from "./ViewDetail.vue?vue&type=template&id=51f9faf8&scoped=true"
import script from "./ViewDetail.vue?vue&type=script&lang=js"
export * from "./ViewDetail.vue?vue&type=script&lang=js"

import "./ViewDetail.vue?vue&type=style&index=0&id=51f9faf8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51f9faf8"

export default script